import React from 'react';

function ArrowLeft({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = '#fff',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7425 8.0865l-4.121 4.121 4.121 4.121c.391.391.391 1.024 0 1.414-.391.391-1.024.391-1.414 0l-4.122-4.121c-.781-.781-.781-2.047 0-2.828l4.122-4.121c.39-.391 1.023-.391 1.414 0s.391 1.023 0 1.414z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}

export default ArrowLeft;
